<script setup lang="ts">
  import { IconHanger, IconBox, Text } from "@ui-kit";

  const { location } = defineProps<{ location: string }>();

  const emit = defineEmits<{
    (e: "click:shopfloor"): void;
    (e: "click:store"): void;
  }>();
</script>

<template>
  <div class="main-page-switch-location">
    <div
      class="main-page-switch-location__button-background"
      :class="{
        'main-page-switch-location__button-background--left': location === 'shopfloor',
        'main-page-switch-location__button-background--right': location === 'store',
      }"
    ></div>
    <button
      class="main-page-switch-location__button"
      :class="{ 'main-page-switch-location__button--active': location === 'shopfloor' }"
      @click="emit('click:shopfloor')"
    >
      <IconHanger style="width: 28px; height: 28px" />
      <Text font="body-medium-14" color="secondary">{{ $t("Зал") }}</Text>
    </button>
    <button
      class="main-page-switch-location__button"
      :class="{ 'main-page-switch-location__button--active': location === 'store' }"
      @click="emit('click:store')"
    >
      <IconBox style="width: 28px; height: 28px" />
      <Text font="body-medium-14" color="secondary">{{ $t("Склад") }}</Text>
    </button>
  </div>
</template>

<style scoped>
  .main-page-switch-location {
    display: flex;
    padding: 4px;
    gap: 8px;
    width: 200px;
    height: 64px;
    border-radius: 28px;
    overflow: hidden;
    position: relative;
    box-shadow: var(--sf-shadow-glass);
    backdrop-filter: var(--sf-shadow-blur-glass);
    background-color: var(--sf-base-background-tabbar);
  }

  .main-page-switch-location__button-background {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 100px;
    height: 56px;
    border-radius: 24px;
    background-color: var(--sf-base-background-white);
    box-shadow: var(--sf-shadow-bot-s);
    z-index: 0;
    transition: transform 0.4s cubic-bezier(0.2, 1.25, 0.6, 1);
    will-change: transform;
  }

  .main-page-switch-location__button-background--left {
    transform: translateX(0);
  }

  .main-page-switch-location__button-background--right {
    transform: translateX(92px);
  }

  .main-page-switch-location__button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: none;
    z-index: 1;

    & :deep(.icon) {
      stroke: var(--sf-base-icon-secondary);
    }
  }

  .main-page-switch-location__button--active {
    color: var(--sf-base-text-primary);

    & :deep(.icon) {
      stroke: var(--sf-base-icon-primary);
    }

    & :deep(.text) {
      color: var(--sf-base-text-primary);
    }
  }
</style>
